<template>
    <div class="main-box">
        <div class="main-container">
            <el-row>
                <el-col :span="18" class="left-container" :offset="hiddenAll?3:0">
                    <div class="detail-query">
                        <span class="title">职位筛选</span>
                        <div class="main-condition">
                            <el-input placeholder="输入职位关键字" clearable v-model="searchForm.postName">
                                <template slot="append">
                                    <el-button type="primary" @click="searchClick">搜索岗位</el-button>
                                </template>
                            </el-input>
                        </div>
                        <el-row class="minor-condition">
                            <el-col :span="8" class="item">
                                <el-select style="width:100%" clearable placeholder="工作地点" v-model="searchForm.areaId" @change="searchClick">
                                    <el-option v-for="item in areaList" :key="item.areaId" :label="item.areaName" :value="item.areaId"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="8" class="item">
                                <el-select style="width:100%" clearable placeholder="岗位类型" v-model="searchForm.postTypeId" @change="searchClick">
                                    <el-option v-for="item in postTypeList" :key="item.postTypeId" :label="item.postTypeName" :value="item.postTypeId"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="8" class="item">
                                <el-select style="width:100%" clearable placeholder="所属公司" v-model="searchForm.orgId" @change="searchClick">
                                    <el-option v-for="item in orgList" :key="item.orgId" :label="item.nickName" :value="item.orgId"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="detail-list" v-loading="loading" :style="loading?{ minHeight: '125px' }: ''">
                        <div class="link" v-for="post of postList" :key="post.postId">
                            <div class="post" v-if="post.postId===174" @click="goJDY()">
                                <div class="title" :class="searchForm.recruitmentFaceToType === ''?'title-type':''">
                                    <span class="urgent" v-if="post.urgentFlag === 1">急</span>{{post.postName}}
                                    <div class="type" v-if="searchForm.recruitmentFaceToType === ''">
                                        {{post.recruitmentFaceToType === 1?'社会招聘': post.recruitmentFaceToType === 2?'校园招聘': post.recruitmentFaceToType === 3?'工人招聘':''}}
                                    </div>
                                </div>
                                <div class="salary" v-if="[null, '', undefined].indexOf(post.minimalSalary) === -1 &&
                                    [null, '', undefined].indexOf(post.maximumSalary) === -1 && [null, '', undefined].indexOf(post.salaryMonth) === -1">
                                    {{(post.minimalSalary === 0 && post.maximumSalary === 0)?'':(post.minimalSalary + '-' + post.maximumSalary + 'K·' + post.salaryMonth + '薪')}}
                                </div>

                                <div class="status">
                                    <span class="status-item" v-if="post.org" v-html="post.org.orgName"></span>
                                    <span class="status-item" v-if="post.postType" v-html="post.postType.postTypeName"></span>
                                    <span class="status-item" v-if="post.demandNumber" v-html="post.demandNumber + '人'"></span>
                                </div>
                                <div class="area" v-if="post.area" v-html="post.area.areaName"></div>
                            </div>
                         <div class="post" v-else  @click="postDetail(post)">
                                <div class="title" :class="searchForm.recruitmentFaceToType === ''?'title-type':''">
                                    <span class="urgent" v-if="post.urgentFlag === 1">急</span>{{post.postName}}
                                    <div class="type" v-if="searchForm.recruitmentFaceToType === ''">
                                        {{post.recruitmentFaceToType === 1?'社会招聘': post.recruitmentFaceToType === 2?'校园招聘': post.recruitmentFaceToType === 3?'工人招聘':''}}
                                    </div>
                                </div>
                                <div class="salary" v-if="[null, '', undefined].indexOf(post.minimalSalary) === -1 &&
                                    [null, '', undefined].indexOf(post.maximumSalary) === -1 && [null, '', undefined].indexOf(post.salaryMonth) === -1">
                                    {{(post.minimalSalary === 0 && post.maximumSalary === 0)?'':(post.minimalSalary + '-' + post.maximumSalary + 'K·' + post.salaryMonth + '薪')}}
                                </div>

                                <div class="status">
                                    <span class="status-item" v-if="post.org" v-html="post.org.orgName"></span>
                                    <span class="status-item" v-if="post.postType" v-html="post.postType.postTypeName"></span>
                                    <span class="status-item" v-if="post.demandNumber" v-html="post.demandNumber + '人'"></span>
                                </div>
                                <div class="area" v-if="post.area" v-html="post.area.areaName"></div>
                            </div>
                        </div>
                        <div class="empty" v-if="!loading && pagination.total === 0">尚无任何相关职位</div>
                    </div>
                    <div class="detail-pagination" v-if="pagination.total !== 0">
                        <el-pagination background layout="prev, pager, next" :total="pagination.total" @current-change="currentChange"
                        :page-size="pagination.pageSize" :current-page="pagination.current"></el-pagination>
                    </div>
                </el-col>
                <el-col :span="6" class="right-container" v-if="!hiddenAll">
                    <NewestPost @change="searchInitial" :channelType="searchForm.recruitmentFaceToType"></NewestPost>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import requests from '@/utils/requests';
import NewestPost from './components/NewestPost.vue';
import getPageTypeNumber from '@/plugins/mixins/getPageTypeNumber';
export default {
    name: 'Job',
    components: { NewestPost },
    mixins: [getPageTypeNumber],
    watch: {
        $route: {
            handler(to, from) {
                if (!from || to.path === from.path) {
                    return;
                }
                let needsearch = false;
                for (const item of [{ key: '/social', type: 1 }, { key: '/campus', type: 2 }, { key: '/worker', type: 3 }]) {
                    if (to.path.indexOf(item.key) !== -1) {
                        this.searchForm.recruitmentFaceToType = item.type;
                    }
                    if (from.path.indexOf(item.key) !== -1) {
                        needsearch = true;
                    }
                }
                if (needsearch) {
                    this.initialQueryFlag = true;
                    this.searchInitial();
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            initialQueryFlag: true,
            initialQuery: {},
            searchForm: { postName: '', areaId: '', postTypeId: '', orgId: '', recruitmentFaceToType: '', postList: '' },
            checkedForm: {},
            pagination: { pageSize: 15, current: 1, total: 0 },
            loading: false,
            newLoading: false,
            areaList: [],
            postTypeList: [],
            orgList: [],
            postList: [],
            hiddenAll: false
        };
    },
    created() {
        this.initialQuery = JSON.parse(JSON.stringify(this.$route.query));
        this.searchForm.postName = this.initialQuery.postName ? this.initialQuery.postName : '';
        this.initialQuery.postName = '';
        // 获取工作地点
        requests.job.getAllArea().then(v => {
            this.areaList = v;
            this.searchForm.areaId = this.initialQuery.areaId ? parseInt(this.initialQuery.areaId) : '';
            this.initialQuery.areaId = '';
        });
        // 获取岗位类型
        requests.job.getAllPostType().then(v => {
            this.postTypeList = v;
            this.searchForm.postTypeId = this.initialQuery.postTypeId ? parseInt(this.initialQuery.postTypeId) : '';
            this.initialQuery.postTypeId = '';
        });
        // 获取所属公司
        requests.job.getAllOrg().then(v => {
            this.orgList = v;
            this.searchForm.orgId = this.initialQuery.orgId ? parseInt(this.initialQuery.orgId) : '';
            this.initialQuery.orgId = '';
        });
    },
    mounted() {
        this.hiddenAll = !!this.$route.meta.hiddenAll;
        this.searchForm.recruitmentFaceToType = this.pageTypeNumber;
        this.searchForm.postList = this.$route.query.selected;
        this.search();
    },
    methods: {
        goJDY() {
            window.open('https://t937olu49a.jiandaoyun.com/f/6141631f8c71c20008e84ffb', '_blank');
        },
        // 重置条件并查询
        searchInitial() {
            this.searchForm.postName = '';
            this.searchForm.areaId = '';
            this.searchForm.postTypeId = '';
            this.searchForm.orgId = '';
            this.pagination.current = 1;
            this.search();
        },
        searchClick() {
            this.pagination.current = 1;
            this.search();
        },
        // 查询
        search() {
            // 同样的条件无法再次搜索
            if (this.checkedForm.postName === this.searchForm.postName && this.checkedForm.areaId === this.searchForm.areaId &&
                this.checkedForm.postTypeId === this.searchForm.postTypeId && this.checkedForm.orgId === this.searchForm.orgId && !this.initialQueryFlag &&
                this.checkedForm.current === this.pagination.current) {
                return;
            }
            this.checkedForm = JSON.parse(JSON.stringify(this.searchForm));
            this.checkedForm.current = this.pagination.current;
            this.loading = true;
            this.postList = [];
            this.addQuery();
            requests.job.getPostListByParams(this.pagination.pageSize, this.pagination.current, this.searchForm.recruitmentFaceToType,
                this.searchForm.postTypeId || this.initialQuery.postTypeId, this.searchForm.areaId || this.initialQuery.areaId,
                this.searchForm.orgId || this.initialQuery.orgId, this.searchForm.postName, this.searchForm.postList).then(v => {
                this.postList = v.data;
                this.pagination.total = v.total;
                this.loading = false;
                this.initialQueryFlag = false;
            });
        },
        // 分页栏当前页数修改
        currentChange(num) {
            this.pagination.current = num;
            this.search();
        },
        // 详情点击
        postDetail(post) {
            this.$store.commit('changeCurrentType', post.recruitmentFaceToType);
            let url = '/post/' + post.postId;
            if (this.$store.state.promoterId) {
                url += '?promoterId=' + this.$store.state.promoterId;
            }
            this.$router.push(url);
        },
        // 地址栏添加查询条件
        addQuery() {
            const query = JSON.parse(JSON.stringify(this.$route.query));
            for (const key of ['postName', 'areaId', 'postTypeId', 'orgId']) {
                if (this.searchForm[key]) {
                    query[key] = this.searchForm[key];
                }
                if (this.initialQuery[key]) {
                    query[key] = this.initialQuery[key];
                }
            }
            if (this.pagination.current !== 1) {
                query.current = this.pagination.current;
            }
            let variant = false;
            for (const value in query) {
                if (query[value] && query[value].toString() !== this.$route.query[value]) {
                    variant = true;
                    break;
                }
            }
            if (!variant && Object.keys(query).length === Object.keys(this.$route.query).length) {
                return;
            }
            this.$router.push({
                query: query
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.main-box {
    overflow: auto;
    position: relative;
    height: 100%;
    border-top: 80px solid #00003C;
    box-sizing: border-box;
}
.main-container {
    margin-top: 30px;
    width: 1200px;
    min-width: 1200px;
    height: 100%;
    box-sizing: border-box;
    margin: auto;
    .detail-query {
        background: #fff;
        padding: 0 30px 28px;
        .title {
            display: block;
            height: 56px;
            line-height: 56px;
            font-size: 16px;
        }
        .minor-condition {
            margin-top: 15px;
            .item {
                padding: 0 3px;
            }
            .item:first-child {
                padding-left: 0;
                padding-right: 6px;
            }
            .item:last-child {
                padding-left: 6px;
                padding-right: 0;
            }
        }
    }
    .detail-list {
        margin-top: 15px;
        background: #fff;
        .link {
            padding: 0 30px;
            .post {
                padding: 20px 0;
                border-bottom: 1px solid #eee;
                cursor: pointer;
            }
            .title-type {
                padding-right: 100px;
                position: relative;
                .type {
                    position: absolute;
                    right: 0;
                    top: 0;
                    background: #ecf5ff;
                    font-size: 14px;
                    padding: 4px 8px;
                    color:#0082EB;
                    border-radius: 5px;
                }
            }
        }
        .title {
            margin-bottom: 10px;
            font-size: 18px;
            font-weight: 600;
        }
        .status {
            font-size: 14px;
            line-height: 20px;
            color: #a2a4a8;
            .status-item {
               padding-right: 10px;
                margin-right: 10px;
                border-right: 1px solid #f4f4f5;
            }
            .status-item:last-child {
                border-right: none;
            }
        }
        .area {
            margin-top: 10px;
            white-space: pre;
            color: #575d6a;
            font-size: 14px;
        }
        .empty {
            padding: 20px 0;
            text-align: center;
        }
        .salary {
            color: #ff6b6b;
            font-size: 16px;
            line-height: 20px;
            margin-bottom: 11px;
        }
    }
    .detail-pagination {
        margin-top: 20px;
        text-align: center;
    }
}
.left-container, .right-container {
    padding: 0 8px;
    margin-top: 30px;
}
</style>
<style scoped>
.main-condition >>> .el-input-group__append {
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
}
</style>
